// extracted by mini-css-extract-plugin
module.exports = {"error":"Error--error--2c4Ja"};